"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSecondInterval = void 0;
const react_1 = __importStar(require("react"));
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const DRNTimeUtil_1 = require("./DRNTimeUtil");
const withSecondInterval = (WrappedComponent) => {
    return (0, hoist_non_react_statics_1.default)(class CountdownWrapper extends react_1.PureComponent {
        constructor() {
            super(...arguments);
            this.state = {
                expired: false,
                remaining: 0,
            };
            this.timer = null;
            this.checkEndTimestamp = () => {
                const { endTimestamp } = this.props;
                this.setState({ endTimestamp }, this.startTimer);
            };
            this.startTimer = () => {
                this.stopTimer();
                const { endTimestamp } = this.state;
                if (!endTimestamp)
                    return;
                const { finished, remaining } = (0, DRNTimeUtil_1.calculateRemainingTime)(endTimestamp);
                if (finished) {
                    this.setState({ expired: true, remaining: 0 });
                    return;
                }
                this.setState({ remaining }, () => {
                    this.timer = setInterval(this.advanceCountdown, 1000);
                });
            };
            this.stopTimer = () => {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            };
            this.advanceCountdown = () => {
                const { remaining } = this.state;
                if (remaining < 1) {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.setState({ expired: true });
                    return;
                }
                this.setState({ remaining: remaining - 1 });
            };
        }
        componentDidMount() {
            this.checkEndTimestamp();
        }
        componentWillUnmount() {
            this.stopTimer();
        }
        render() {
            const { endTimestamp, expired, remaining } = this.state;
            const hasExpired = endTimestamp ? expired : this.props.parentExpired;
            return react_1.default.createElement(WrappedComponent, { ...this.props, expired: hasExpired, remaining: remaining });
        }
    }, WrappedComponent);
};
exports.withSecondInterval = withSecondInterval;
exports.default = exports.withSecondInterval;
